import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Stack,
  Icon,
  Button,
  Divider,
  Heading,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import { FaCalendarAlt, FaStar } from "react-icons/fa";
import axios from "axios";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const EventItem = ({ title }) => (
  <Flex
    align="center"
    p={2}
    borderRadius="md"
    bg="gray.50"
    _hover={{ bg: "teal.100" }}
  >
    <Icon as={FaStar} color="teal.600" boxSize={3} mr={3} />
    <Text fontWeight="semibold" fontSize="sm" color="gray.800">
      {title}
    </Text>
  </Flex>
);

const EventBoard = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const cardBg = useColorModeValue("white", "gray.700");

  const userId = sessionStorage.getItem("user_id");
  const userType = sessionStorage.getItem("user_type");

  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      setError(null);

      try {
        let url = "";
        let method = "POST";
        let payload = null;

        // --- (Functionality and URL logic remains unchanged) ---
        if (userType === "3") {
          url = `${BASE_URL}/student/list_events.php`;
          payload = { pass: userId };
        } else if (userType === "4") {
          url = `${BASE_URL}/guardian/list_events.php`;
          payload = { pass: userId };
        } else if (userType === "2") {
          url = `${BASE_URL}/staff/profile/list_teachers_event.php?user_id=${userId}`;
          method = "GET";
        } else {
          throw new Error("Invalid user type");
        }

        let response;
        if (method === "POST") {
          response = await axios.post(url, payload);
        } else {
          response = await axios.get(url);
        }
        // --------------------------------------------------------

        if (response.data.success) {
          setEvents((response.data.data || []).slice(0, 6));
        } else {
          setError(response.data.message || "Failed to fetch events.");
        }
      } catch (err) {
        setError("An error occurred while fetching events.");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [userId, userType]);

  if (loading) return <Text p={5}>Loading events...</Text>;
  if (error)
    return (
      <Text p={5} color="red.500">
        {error}
      </Text>
    );

  return (
    <Box
      bg={cardBg}
      p={5}
      borderRadius="xs"
      boxShadow="md"
      borderWidth="1px"
      borderColor="gray.100"
      overflow="hidden"
    >
      {/* ==================== Header Section ==================== */}
      <Box
        mb={4}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Heading
          size="md"
          fontWeight="bold"
          color="teal.600"
          display="flex"
          alignItems="center"
        >
          <Icon as={FaCalendarAlt} mr={3} color="teal.500" />
          Upcoming Events
        </Heading>
        <Link to="/announcement/individual/event">
          <Button
            size="sm"
            variant="ghost"
            colorScheme="teal"
            fontWeight="semibold"
          >
            View All
          </Button>
        </Link>
      </Box>
      <Divider mb={4} />

      {/* ==================== Events List ==================== */}
      <Stack spacing={2} maxHeight="300px" overflowY="auto">
        {events.length > 0 ? (
          events.map((event) => (
            <EventItem key={event.id} title={event.event_title} />
          ))
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100px"
            bg="gray.50"
            borderRadius="md"
          >
            <Text fontSize="md" color="gray.500" fontWeight="medium">
              No upcoming events scheduled.
            </Text>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default EventBoard;
